module.exports = require("npm:swiper@4.2.2/dist/js/swiper.js");